// extracted by mini-css-extract-plugin
export var body = "DevToolsPanel-module--body--240e7";
export var close = "DevToolsPanel-module--close--0ccde";
export var header = "DevToolsPanel-module--header--007d6";
export var link = "DevToolsPanel-module--link--ffeb0";
export var panel = "DevToolsPanel-module--panel--f8cff";
export var row = "DevToolsPanel-module--row--f9399";
export var rowLabel = "DevToolsPanel-module--rowLabel--c749f";
export var title = "DevToolsPanel-module--title--202a7";
export var toggle = "DevToolsPanel-module--toggle--37fb7";
export var toggleOff = "DevToolsPanel-module--toggleOff--2ff65";
export var toggleOn = "DevToolsPanel-module--toggleOn--1689f";